// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var V4 = require("uuid/v4");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NewPropertyPageRelayFormData_serverDraft_graphql = require("../../../__generated__/NewPropertyPageRelayFormData_serverDraft_graphql.bs.js");
var NewPropertyPageRelayFormData_inlineServerDraft_graphql = require("../../../__generated__/NewPropertyPageRelayFormData_inlineServerDraft_graphql.bs.js");

var forSalePropertyTypeEnumV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var leaseLengthValue_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.leaseLengthValue_decode;

var rentalPropertyTypeEnumV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var convertFragment = NewPropertyPageRelayFormData_serverDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NewPropertyPageRelayFormData_serverDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NewPropertyPageRelayFormData_serverDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NewPropertyPageRelayFormData_serverDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NewPropertyPageRelayFormData_serverDraft_graphql.node, convertFragment, fRef);
}

var ServerDraftFragment_draftV5Status_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.draftV5Status_decode;

var ServerDraftFragment_draftV5Status_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.draftV5Status_fromString;

var ServerDraftFragment_forSalePropertyTypeEnumV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var ServerDraftFragment_leaseLengthValue_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.leaseLengthValue_fromString;

var ServerDraftFragment_mlsListingTypeV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.mlsListingTypeV5_decode;

var ServerDraftFragment_mlsListingTypeV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.mlsListingTypeV5_fromString;

var ServerDraftFragment_onOrOffV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.onOrOffV5_decode;

var ServerDraftFragment_onOrOffV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.onOrOffV5_fromString;

var ServerDraftFragment_rentalPropertyTypeEnumV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var ServerDraftFragment_showingTypeV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.showingTypeV5_decode;

var ServerDraftFragment_showingTypeV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.showingTypeV5_fromString;

var ServerDraftFragment = {
  draftV5Status_decode: ServerDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: ServerDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: ServerDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: ServerDraftFragment_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: ServerDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: ServerDraftFragment_mlsListingTypeV5_fromString,
  onOrOffV5_decode: ServerDraftFragment_onOrOffV5_decode,
  onOrOffV5_fromString: ServerDraftFragment_onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: ServerDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: ServerDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ServerDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NewPropertyPageRelayFormData_inlineServerDraft_graphql.node, convertFragment$1, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(NewPropertyPageRelayFormData_inlineServerDraft_graphql.node, convertFragment$1, fRef);
}

var InlineServerDraftFragment_draftV5Status_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.draftV5Status_decode;

var InlineServerDraftFragment_draftV5Status_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.draftV5Status_fromString;

var InlineServerDraftFragment_forSalePropertyTypeEnumV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var InlineServerDraftFragment_forSalePropertyTypeEnumV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var InlineServerDraftFragment_leaseLengthValue_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.leaseLengthValue_decode;

var InlineServerDraftFragment_leaseLengthValue_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.leaseLengthValue_fromString;

var InlineServerDraftFragment_mlsListingTypeV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.mlsListingTypeV5_decode;

var InlineServerDraftFragment_mlsListingTypeV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.mlsListingTypeV5_fromString;

var InlineServerDraftFragment_onOrOffV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.onOrOffV5_decode;

var InlineServerDraftFragment_onOrOffV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.onOrOffV5_fromString;

var InlineServerDraftFragment_rentalPropertyTypeEnumV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var InlineServerDraftFragment_rentalPropertyTypeEnumV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var InlineServerDraftFragment_showingTypeV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.showingTypeV5_decode;

var InlineServerDraftFragment_showingTypeV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.showingTypeV5_fromString;

var InlineServerDraftFragment = {
  draftV5Status_decode: InlineServerDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: InlineServerDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: InlineServerDraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: InlineServerDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: InlineServerDraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: InlineServerDraftFragment_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: InlineServerDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: InlineServerDraftFragment_mlsListingTypeV5_fromString,
  onOrOffV5_decode: InlineServerDraftFragment_onOrOffV5_decode,
  onOrOffV5_fromString: InlineServerDraftFragment_onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: InlineServerDraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: InlineServerDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: InlineServerDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: InlineServerDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  readInline: readInline
};

function serverDraftToLocalDraft(serverDraft) {
  var match = serverDraft.chapter;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.preferences;
    if (match$1 !== undefined) {
      var match$2 = match$1.mlsComingSoon;
      tmp = match$2 !== undefined && (match$2 === "OFF" || match$2 === "ON") && match$2 !== "OFF" ? true : false;
    } else {
      tmp = false;
    }
  } else {
    tmp = false;
  }
  var draftProperty = serverDraft.draftProperty;
  var tmp$1;
  if (draftProperty !== undefined) {
    var propertyData = draftProperty.propertyData;
    var commission;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataForSaleV5" :
            commission = propertyData.commission;
            break;
        case "DraftPropertyDataRentalV5" :
        case "__unselected" :
            commission = undefined;
            break;
        
      }
    } else {
      commission = undefined;
    }
    var match$3 = draftProperty.price;
    var match$4;
    if (match$3 !== undefined) {
      switch (match$3.__typename) {
        case "DraftPropertyPriceRange" :
            match$4 = [
              Core__Option.map(match$3.minPrice, (function (p) {
                      return p.value;
                    })),
              Core__Option.map(match$3.maxPrice, (function (p) {
                      return p.value;
                    })),
              true
            ];
            break;
        case "DraftPropertyExactPrice" :
        case "__unselected" :
            match$4 = [
              undefined,
              undefined,
              false
            ];
            break;
        
      }
    } else {
      match$4 = [
        undefined,
        undefined,
        false
      ];
    }
    var match$5 = draftProperty.price;
    var price;
    if (match$5 !== undefined) {
      switch (match$5.__typename) {
        case "DraftPropertyExactPrice" :
            price = Core__Option.map(match$5.price, (function (p) {
                    return p.value;
                  }));
            break;
        case "DraftPropertyPriceRange" :
        case "__unselected" :
            price = undefined;
            break;
        
      }
    } else {
      price = undefined;
    }
    var match$6;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
            match$6 = [
              propertyData.availableFrom,
              propertyData.leaseLength
            ];
            break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
            match$6 = [
              undefined,
              undefined
            ];
            break;
        
      }
    } else {
      match$6 = [
        undefined,
        undefined
      ];
    }
    var match$7 = draftProperty.displayNeighborhood;
    var tmp$2;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataForSaleV5" :
            tmp$2 = Core__Option.flatMap(propertyData.forSalePropertyType, forSalePropertyTypeEnumV5_decode);
            break;
        case "DraftPropertyDataRentalV5" :
        case "__unselected" :
            tmp$2 = undefined;
            break;
        
      }
    } else {
      tmp$2 = undefined;
    }
    var match$8 = draftProperty.geocodingData;
    var tmp$3;
    if (match$8 !== undefined) {
      var lat = match$8.lat;
      if (lat !== undefined) {
        var lon = match$8.lon;
        if (lon !== undefined) {
          var standardizedAddress = match$8.standardizedAddress;
          if (standardizedAddress !== undefined) {
            var standardizedCity = match$8.standardizedCity;
            if (standardizedCity !== undefined) {
              var standardizedState = match$8.standardizedState;
              if (standardizedState !== undefined) {
                var standardizedZip = match$8.standardizedZip;
                tmp$3 = standardizedZip !== undefined ? ({
                      lat: lat,
                      lon: lon,
                      standardizedAddress: standardizedAddress,
                      standardizedCity: standardizedCity,
                      standardizedState: standardizedState,
                      standardizedZip: standardizedZip
                    }) : undefined;
              } else {
                tmp$3 = undefined;
              }
            } else {
              tmp$3 = undefined;
            }
          } else {
            tmp$3 = undefined;
          }
        } else {
          tmp$3 = undefined;
        }
      } else {
        tmp$3 = undefined;
      }
    } else {
      tmp$3 = undefined;
    }
    var tmp$4;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
            tmp$4 = "RENTAL";
            break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
            tmp$4 = "FOR_SALE";
            break;
        
      }
    } else {
      tmp$4 = "FOR_SALE";
    }
    var tmp$5;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
            tmp$5 = Core__Option.flatMap(propertyData.rentalPropertyType, rentalPropertyTypeEnumV5_decode);
            break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
            tmp$5 = undefined;
            break;
        
      }
    } else {
      tmp$5 = undefined;
    }
    var match$9 = draftProperty.userSelectedArea;
    tmp$1 = {
      address: draftProperty.address,
      addressToGeocode: draftProperty.address,
      availableFrom: match$6[0],
      baths: draftProperty.baths,
      beds: draftProperty.beds,
      commission: commission,
      description: draftProperty.description,
      displayNeighborhood: match$7 !== undefined ? ({
            id: match$7.id,
            label: match$7.label
          }) : undefined,
      files: Core__Option.getOr(Core__Option.map(draftProperty.files, (function (files) {
                  return Core__Array.filterMap(files, (function (f) {
                                var contentType = f.contentType;
                                if (contentType === undefined) {
                                  return ;
                                }
                                var fileName = f.fileName;
                                if (fileName !== undefined) {
                                  return {
                                          contentType: contentType,
                                          fileName: fileName,
                                          id: f.id,
                                          key: f.key
                                        };
                                }
                                
                              }));
                })), []),
      forSalePropertyType: tmp$2,
      geocodingData: tmp$3,
      goingOnMls: draftProperty.goingOnMls,
      halfBaths: draftProperty.halfBaths,
      hideAddress: draftProperty.hideAddress,
      images: Core__Option.getOr(Core__Option.map(draftProperty.images, (function (images) {
                  return Core__Array.filterMap(images, (function (img) {
                                var contentType = img.contentType;
                                if (contentType === undefined) {
                                  return ;
                                }
                                var fileName = img.fileName;
                                if (fileName !== undefined) {
                                  return {
                                          contentType: contentType,
                                          fileName: fileName,
                                          id: img.id,
                                          key: img.key,
                                          previewUrl: img.url
                                        };
                                }
                                
                              }));
                })), []),
      leaseLength: Core__Option.flatMap(Core__Option.map(match$6[1], (function (p) {
                  return p.value;
                })), leaseLengthValue_decode),
      livingArea: draftProperty.livingArea,
      lotSize: draftProperty.lotSize,
      maxPrice: match$4[1],
      minPrice: match$4[0],
      mlsListingType: draftProperty.mlsListingType,
      numberOfUnits: draftProperty.numberOfUnits,
      onMlsAt: draftProperty.onMlsAt,
      price: price,
      priceRange: match$4[2],
      propertyType: tmp$4,
      rentalPropertyType: tmp$5,
      selectedArea: match$9 !== undefined ? ({
            id: match$9.id,
            label: match$9.label
          }) : undefined,
      showings: Core__Option.getOr(Core__Option.map(draftProperty.showings, (function (showings) {
                  return showings.map(function (s) {
                              var match = s.id;
                              var match$1 = s.key;
                              return {
                                      date: s.date,
                                      endTime: s.endTime,
                                      id: s.id,
                                      key: match !== undefined ? match : (
                                          match$1 !== undefined ? match$1 : V4()
                                        ),
                                      notes: s.notes,
                                      startTime: s.startTime,
                                      type_: s.typ
                                    };
                            });
                })), []),
      website: draftProperty.website,
      willAcceptOffers: draftProperty.willAcceptOffers,
      willShow: draftProperty.willShow
    };
  } else {
    tmp$1 = {
      address: undefined,
      addressToGeocode: undefined,
      availableFrom: undefined,
      baths: undefined,
      beds: undefined,
      commission: undefined,
      description: undefined,
      displayNeighborhood: undefined,
      files: [],
      forSalePropertyType: undefined,
      geocodingData: undefined,
      goingOnMls: undefined,
      halfBaths: undefined,
      hideAddress: undefined,
      images: [],
      leaseLength: undefined,
      livingArea: undefined,
      lotSize: undefined,
      maxPrice: undefined,
      minPrice: undefined,
      mlsListingType: "ACTIVE",
      numberOfUnits: undefined,
      onMlsAt: undefined,
      price: undefined,
      priceRange: false,
      propertyType: "FOR_SALE",
      rentalPropertyType: undefined,
      selectedArea: undefined,
      showings: [],
      website: undefined,
      willAcceptOffers: undefined,
      willShow: undefined
    };
  }
  return {
          chapterPreferenceMlsComingSoonActivated: tmp,
          draftProperty: tmp$1,
          message: serverDraft.message,
          serverDraftId: serverDraft.databaseId,
          status: serverDraft.status,
          subject: serverDraft.subject,
          timeZone: Core__Option.getOr(Core__Option.flatMap(serverDraft.chapter, (function (c) {
                      return c.timezone;
                    })), "")
        };
}

function toDraftData(raw) {
  return serverDraftToLocalDraft(readInline(raw));
}

var Form;

exports.Form = Form;
exports.ServerDraftFragment = ServerDraftFragment;
exports.InlineServerDraftFragment = InlineServerDraftFragment;
exports.serverDraftToLocalDraft = serverDraftToLocalDraft;
exports.toDraftData = toDraftData;
/* uuid/v4 Not a pure module */
